import React from 'react';
import { UseFormMethods } from 'react-hook-form';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';

interface IShortFormAckProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    signatureCompany?: string;
    signatureName?: string;
    ackType?: number;
    newAcknowledgement?: boolean;
    selectedState?: string;
    selectedCounty?: string;
}

const ShortFormAck = (props: IShortFormAckProps) => {
    return (
        <div className="ack-main" style={{ backgroundColor: 'white' }}>
            {props?.newAcknowledgement === true && (
                <>
                    <div className="double-line" />
                    <h2 className="lh-align-center">(ACKNOWLEDGEMENT)</h2>
                    {!!props.selectedState && props?.selectedState?.length > 0 ? (
                        <div>STATE OF {props?.selectedState?.toUpperCase()}</div>
                    ) : (
                        <div>STATE OF ________________________</div>
                    )}
                    {!!props.selectedCounty && props?.selectedCounty?.length > 0 ? (
                        <div className="mt-2">COUNTY OF {props?.selectedCounty?.toUpperCase()}</div>
                    ) : (
                        <div className="mt-2">COUNTY OF ________________________</div>
                    )}
                    <div className="mt-2">
                        {/*ackBodyFunc(type)*/}
                        {props?.ackType === 1 && (
                            <>
                                <RHFTextArea
                                    label=""
                                    name="text"
                                    defaultValue={
                                        'The foregoing instrument was acknowledged before me on this ________ day of ______________, ______ by <<Appeared>> as <<Title>> of <<Signature Company>>.'
                                    }
                                    style={{ width: '100%', height: '10rem', resize: 'none', border: 'none' }}
                                    register={props.register}
                                    rules={{ required: 'field required' }}
                                />
                            </>
                        )}
                        {props?.ackType === 3 && (
                            <>
                                <RHFTextArea
                                    label=""
                                    name="text"
                                    defaultValue={
                                        'On this _______ day of _______________, ____, before me, _______________________, the undersigned officer, personally appeared <<Signature Name>>,' +
                                        'known to be (or satifactorily proven) to be the person whose name is subscribed as attorney-in-fact for <<Signature Company>>,  and acknowledged that <<Lessor Person>>' +
                                        'executed the same as the act of <<Lessor Possesive>> principal for the purposes therein contained.\n\rIn witness whereof I hereunto set my hand and official seal.'
                                    }
                                    style={{ width: '100%', height: '23rem', resize: 'none', border: 'none' }}
                                    register={props.register}
                                    rules={{ required: 'field required' }}
                                />
                            </>
                        )}
                        {props?.ackType === 8 && (
                            <>
                                <RHFTextArea
                                    label=""
                                    name="text"
                                    defaultValue={
                                        'This instrument was acknowledged before me on this _______ day of _______________, ____,  by <<Signature Name>> of <<Signature Company>> a limited liability company.'
                                    }
                                    style={{ width: '100%', height: '10rem', resize: 'none', border: 'none' }}
                                    register={props.register}
                                    rules={{ required: 'field required' }}
                                />
                            </>
                        )}
                        {props?.ackType === 13 && (
                            <>
                                <RHFTextArea
                                    label=""
                                    name="text"
                                    defaultValue={
                                        'The foregoing instrument was acknowledged before me on this ______ day of ______________, 20_____, by <<Appeared>>'
                                    }
                                    style={{ width: '100%', height: '10rem', resize: 'none', border: 'none' }}
                                    register={props.register}
                                    rules={{ required: 'field required' }}
                                />
                            </>
                        )}
                    </div>

                    <div className="mt-2">________________________________________</div>
                    <div className="mt-2 notary-public lh-half-width lh-align-center">Notary Public</div>
                    <div className="mt-5">Print Name _______________________________________</div>
                    <div className="mt-3">My Commission expires: ________________________</div>
                    <div className="mt-3">Commission Number: ________________________</div>
                    <div className="double-line" />
                </>
            )}
            {props?.newAcknowledgement === false && (
                <>
                    <h2 className="lh-align-center">(ACKNOWLEDGMENT)</h2>
                    <RHFTextArea
                        label=""
                        name="text"
                        style={{ width: '100%', height: '30rem', resize: 'none', border: 'none' }}
                        register={props.register}
                        rules={{ required: 'field required' }}
                    />
                </>
            )}
        </div>
    );
};

export default ShortFormAck;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/Acknowledgments/Short-FormAck.tsx